import { categorizeAsset } from "./categorizeAsset";
import { Guard } from "../util";
import { AssetType } from "lib/types/assets/AssetType";
import { AssetCategoryPresets } from "lib/types/assets/AssetCategoryPresets";
import { getModelPageTypeForCategory } from "lib/types/assets/ModelPageType";

export function getAssetPageType(type: AssetType, extension: string) {
  Guard.require(type, "type");
  const category = categorizeAsset(type, extension);
  const modelPageType = getModelPageTypeForCategory(category);
  if (modelPageType) return modelPageType;
  const otherPageCategories =
    AssetCategoryPresets.models | AssetCategoryPresets.documents;
  if ((category & otherPageCategories) > 0) return "other";
  if ((category & AssetCategoryPresets.layers) > 0) return "layers";
  throw new Error("Unsupported asset category for asset page type.");
}
